import { mergeStyleSets } from '@uifabric/merge-styles';
// import theme from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  collapseButton: {
    position: 'absolute',
    padding: `${pxToRem(7)} ${pxToRem(10)} ${pxToRem(7)} ${pxToRem(16)}`,
    border: 0,
    cursor: 'pointer',
    zIndex: 2,
    textAlign: 'left',
    background: 0,
    i: {
      display: 'inline',
    },
  },
});
